<template>
  <div class="sub-comment-item">
    <div class="time">{{ comment.createdAt | formatTime  }}</div>
    <UserItem :avatar="comment['UserInfo.avatar']" :name="comment['UserInfo.name']" :ont="comment['UserInfo.ontid']" />
    <div class="content">{{ comment.content }}</div>
  </div>
</template>

<script>
import UserItem from '@/components/UserItem.vue';

export default {
  name: 'SubCommentItem',
  components: { UserItem },
  props: {
    comment: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .sub-comment-item {
    padding: 30px 20px;
    background: var(--background-panel);
  }

  .time {
    float: right;
    line-height: 20px;
    color: var(--color-content);
  }

  .content {
    margin-top: $padding-common;
  }
</style>
